import { useRef, useState } from "react";
import { useTranslation } from "next-i18next";

import Brands from "../category/filters/Brands";
// import Colors from "../category/filters/Colors";
// import Prices from "../category/filters/Prices";
// import Ratings from "../category/filters/Ratings";
import FilterIcon from "../icons/FilterIcon";
import CloseIcon from "../icons/CloseIcon";
import ArrowIcon from "../icons/ArrowIcon";
import useOnClickOutside from "@/hooks/useOnClickOutside";

const Filter = ({
  setSelectedFilterKeys,
  selectedFilterKeys,
  filters,
  handleFilter,
  handleResetFilter,
  setShowType,
  fromSearch = null,
}) => {
  const [state, setState] = useState(false);
  const {
    t,
    i18n: { language },
  } = useTranslation("category");
  const ref = useRef();
  useOnClickOutside([ref], () => setShowType(null));

  return (
    <div
      ref={ref}
      className="absolute bottom-0 left-0 w-screen min-h-[50vh] max-h-screen overflow-y-auto bg-white flex flex-col gap-2"
    >
      <div className="flex items-center justify-between  px-2 py-3 border-b">
        <div className="flex items-center gap-2">
          <FilterIcon className="size-5" />
          <span className="text-sm font-bold">{t("All Filter")}</span>
        </div>
        <button onClick={() => setShowType && setShowType(false)}>
          <CloseIcon className="size-3 max-sm:size-2.5" />
        </button>
      </div>
      <div className="p-2 border-b flex-grow">
        {Array.isArray(filters)
          ? filters?.map((item, key) => {
              const title = item?.label || "";
              const options = item?.filterable_values || [];
              const code = item?.filter_key || "";
              return options?.length ? (
                <div
                  className={`${
                    key == filters?.length - 1
                      ? "mb-0"
                      : "mb-7 last:max-sm:mb-2 first:max-sm:mt-2"
                  }`}
                  key={key}
                >
                  <div
                    onClick={() => setState(state === title ? false : title)}
                    className={`flex items-center justify-between mb-3`}
                  >
                    <span className="font-semibold max-sm:text-xs">
                      {title}
                    </span>
                    <ArrowIcon
                      className={`h-3.5 w-3.5 transition-all text-zinc-500 ${
                        state === title && "rotate-90"
                      } ${language === "en" ? "rotate-0" : "rotate-180"}`}
                    />
                  </div>
                  {state === title && (
                    <Brands
                      {...{
                        data: options,
                        selectedFilterKeys,
                        code,
                        handleFilter,
                        t,
                      }}
                    />
                  )}
                </div>
              ) : null;
            })
          : null}

        {fromSearch && Array.isArray(fromSearch) ? (
          <div className="p-3 mb-3 border rounded-md">
            <p className="mb-2 text-lg font-bold sm:text-xl">
              {t(fromSearch?.at(0)?.parentName)}
            </p>
            <Brands
              {...{
                data: fromSearch?.map((item) => ({
                  Key: item?.value,
                  Label: item?.label,
                  DocCount: item?.count,
                })),
                selectedFilterKeys,
                handleFilter,
              }}
            />
          </div>
        ) : null}
        {/* <div className="mb-2.5">
          <div
            onClick={() => setState(state === "brands" ? false : "brands")}
            className="flex items-center justify-between mb-1.5"
          >
            <span className="font-bold">{t("Brands")}</span>
            <ArrowIcon
              className={`h-3.5 w-3.5 text-zinc-500 ${
                language === "en" ? "rotate-0" : "rotate-180"
              }`}
            />
          </div>
          {state === "brands" && <Brands />}
        </div> */}
        {/* <div className="mb-2.5">
          <div
            onClick={() => setState(state === "size" ? false : "size")}
            className="flex items-center justify-between"
          >
            <span className="font-bold">{t("Sizes")}</span>
            <ArrowIcon
              className={`h-3.5 w-3.5 text-zinc-500 ${
                language === "en" ? "rotate-0" : "rotate-180"
              }`}
            />
          </div>
          {state === "size" && <Brands />}
        </div>
        <div className="mb-2.5">
          <div
            onClick={() => setState(state === "color" ? false : "color")}
            className="flex items-center justify-between"
          >
            <span className="font-bold">{t("Colors")}</span>
            <ArrowIcon
              className={`h-3.5 w-3.5 text-zinc-500 ${
                language === "en" ? "rotate-0" : "rotate-180"
              }`}
            />
          </div>
          {state === "color" && <Colors />}
        </div>
        <div className="mb-2.5">
          <div
            onClick={() => setState(state === "price" ? false : "price")}
            className="flex items-center justify-between"
          >
            <span className="font-bold">{t("Price")}</span>
            <ArrowIcon
              className={`h-3.5 w-3.5 text-zinc-500 ${
                language === "en" ? "rotate-0" : "rotate-180"
              }`}
            />
          </div>
          {state === "price" && <Prices />}
        </div>
        <div>
          <div
            onClick={() => setState(state === "rate" ? false : "rate")}
            className="flex items-center justify-between"
          >
            <span className="font-bold">{t("Ratings")}</span>
            <ArrowIcon
              className={`h-3.5 w-3.5 text-zinc-500 ${
                language === "en" ? "rotate-0" : "rotate-180"
              }`}
            />
          </div>
          {state === "rate" && <Ratings />}
        </div> */}
      </div>
      <div className="grid grid-cols-2 p-2 max-sm:text-xs gap-2">
        <button
          className="px-1 py-2 text-white rounded-md bg-primary sm:p-2"
          onClick={() => {
            setShowType && setShowType(false);
            setState(false);
          }}
        >
          {t("Show Result")}
        </button>
        <button
          disabled={selectedFilterKeys?.length===0}
          className={`px-1 py-2 text-white rounded-md bg-primary sm:p-2 ${
            selectedFilterKeys?.length > 0 ? "" : "opacity-50"
          }`}
          onClick={() => {
            handleResetFilter();
            fromSearch && setSelectedFilterKeys([]);
          }}
        >
          {t("Reset filter")}
        </button>
      </div>
    </div>
  );
};

export default Filter;
